import React from 'react';
import { lockedReason } from './sharedQueries';

/**
 * Shown in place of the conversation when the viewer can't read a shared
 * query's datasets (PRD-1571 R11, Frame 3). Built from the list row alone:
 * nothing about the conversation is fetched. "Request access" is left out
 * until Product decides where requests go.
 */
function LockedQueryNotice({ thread }) {
  return (
    <div className="resui-card locked-query-notice" role="status">
      <h3 className="locked-query-notice-title">You can&rsquo;t open this query yet</h3>
      <p className="locked-query-notice-text">{lockedReason(thread)}</p>
    </div>
  );
}

export default LockedQueryNotice;
